import { http } from "../../../shared/api/http";

export async function unreadChat(): Promise<any> {
  const res = await http.get(`/restaurant/chat/orders/unread`);
  return res.data;
}